import "./index.css"
import { Card } from "react-bootstrap"
import { CalendarIcon, ChevronRight, Globe, Mail, MapPin, Phone } from "lucide-react"
import { Link } from "react-router-dom"
import { UserInital } from "../../utils/otherHelopers"
import { formatMomentDate } from "../../utils/dateHelper"

const ProfileCard = ({ title, user = {}, link = '#', className = "" }) => {
    const { name, email, role, mobile_no, image, website, office_address, date } = user;

    return (<Link to={link} className={`text-decoration-none d-block profile-card common-shadow common-card rounded-3 border-0 bg-white p-4 ${className}`}>
        <Card.Header className="p-0 mb-3 bg-transparent border-0 d-flex align-items-center justify-content-between  gap-2 mb-0 fw-semibold text-primary fs-base">
            {title}
            <button className="p-0 bg-transparent border-0 primary"><ChevronRight /></button>
        </Card.Header>
        <Card.Body className="p-0">
            <div className="seller-profile-row mb-3">
                <UserInital width={40} name={name} image={image} />
                <div>
                    <h6 className="seller-name mb-0">
                        {name}
                    </h6>
                    <p className="seller-designation">
                        {role}
                    </p>
                    {date ?
                        <p className="fs-md text-secondary d-inline-flex gap-1 align-items-center">
                            <CalendarIcon size={16} className="primary" />
                            <span> {formatMomentDate(date, "DD MMMM, YYYY")}</span>
                        </p> : null}
                </div>
            </div>

            <hr className="border-top opacity-100 my-3" />

            <div className="seller-contact-item">
                <div className="seller-contact-label">
                    <Mail size={16} />
                    <span>Email</span>
                </div>
                <span className="seller-contact-value">
                    {email || "-"}
                </span>
            </div>

            <div className="seller-contact-item">
                <div className="seller-contact-label">
                    <Phone size={16} />
                    <span>Phone</span>
                </div>
                <span className="seller-contact-value">
                    {mobile_no || "-"}
                </span>
            </div>
            {website && <div className="seller-contact-item">
                <div className="seller-contact-label">
                    <Globe size={16} />
                    <span>Website</span>
                </div>
                <span className="seller-contact-value">
                    {website || "-"}
                </span>
            </div>}
            {office_address && <div className="seller-contact-item">
                <div className="seller-contact-label">
                    <MapPin size={16} />
                    <span>Office Address</span>
                </div>
                <span className="seller-contact-value">
                    {office_address || "-"}
                </span>
            </div>}

        </Card.Body></Link>)
}
const TabCard = ({ title, count, className = "", active = false, iconColor = "", iconClassName = "", icon, iconBg = "", image = null, ...rest }) => {
    return (
        <Card
            className={`tab-cards cursor-pointer w-100 ${className} ${active ? 'active' : ""}`}
            {...rest}
        >
            <Card.Body className="p-3 d-flex align-items-center gap-2">

                {/* Left Container: Round background and Icon */}
                {image ? <img src={image} alt={title} className="rounded-circle icon-image" width={40} height={40} /> : <i
                    className={`icon-container rounded-circle ${iconClassName}`}
                    style={{ backgroundColor: iconBg, color: iconColor }}
                >
                    {icon}
                </i>}


                {/* Right Container: Texts */}
                <div className="info-container">
                    <span className="title">{title}</span>
                    <div className="footer">
                        <span className="count">{count}</span>
                    </div>
                </div>

            </Card.Body>
        </Card>
    )
}

export { ProfileCard,TabCard }